import styled, { css } from 'styled-components';

import { buttonResetStyles } from 'src/dispensary/core-menu/components/header/header.styles';

export const HeaderWrapper = styled.div`
  background: var(--dcm-header-bg);
  border-bottom: var(--dcm-header-border-width) solid var(--dcm-header-border-color);
  color: var(--dcm-header-text-color);
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--dcm-header-max-width);
  padding: 0 var(--dcm-header-padding-x);
  position: relative;
  width: 100%;
`;

const buttonStyles = css`
  color: currentColor;
  display: block;
  font-size: var(--dcm-nav-link-font-size);
  font-weight: var(--dcm-nav-link-font-weight);
  line-height: ${20 / 14};
  padding: 8px 8px 8px 0;
`;

export const NavLink = styled.a`
  ${buttonStyles}
`;

export const NavButton = styled.button`
  ${buttonResetStyles}
  ${buttonStyles}

  align-items: center;
  display: flex;
  gap: var(--dcm-space-2);
  justify-content: space-between;
`;

export const Nav = styled.nav`
  align-items: center;
  display: flex;
  flex: 1;
  gap: var(--dcm-header-gap);
  min-height: var(--dcm-header-min-height);
`;

export const UtilityNav = styled.div`
  align-items: center;
  display: flex;
  gap: var(--dcm-header-gap);
  position: relative;
`;

export const Divider = styled.div`
  border-left: 1px solid var(--dcm-header-divider-color);
  height: var(--dcm-header-divider-height);
`;

export const InBetweenMq = styled.div`
  @media (min-width: 880px) and (max-width: 1019px) {
    display: none;
  }

  @media (min-width: 1020px) {
    align-items: center;
    display: flex;
    gap: var(--dcm-header-gap);
  }
`;

export const ShopNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: var(--dcm-space-4);
  padding: 16px 28px;
`;

export const ShopNavHeading = styled.h2`
  color: var(--dcm-header-nav-title-text-color);
  font-size: var(--dcm-nav-heading-font-size);
  font-weight: var(--dcm-nav-heading-font-weight);
  line-height: ${20 / 16};
  margin: 16px 12px;
`;

export const TwoColumnNav = styled.ul`
  column-gap: 10px;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
  width: var(--dcm-nav-two-column-width);
`;

export const ThreeColumnNav = styled.ul`
  column-gap: 10px;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
`;
